import { useState } from 'react';

import { useStateContext } from '../../../contexts/ContextProvider';
import { useLieuxDeLHotel } from '../../api/usePannes';
import BottomSheet from '../../components/BottomSheet';
import Button from '../../components/Button';
import Input from '../../components/Input';
import Text from '../../components/Text';
import { t } from '../../i18n/langue';

/**
 * « Signaler » du technicien : où est la panne ? Une chambre ou un espace de
 * l'hôtel (le tableau ménage, lisible avec `housekeeping.view`), ou « hors
 * chambre ». Le choix ouvre l'appareil photo DANS le tap (exigence iOS), puis la
 * feuille de signalement partagée avec les agents prend le relais.
 */
interface FeuilleChoixLieuProps {
    onChoisir: (serviceId: number | null) => void;
    onFermer: () => void;
}

export default function FeuilleChoixLieu({ onChoisir, onFermer }: FeuilleChoixLieuProps) {
    const { currentFacility } = useStateContext();
    const { data, isLoading, isError, refetch } = useLieuxDeLHotel(currentFacility?.id ?? null, true);
    const [recherche, setRecherche] = useState('');

    const filtre = recherche.trim().toLowerCase();
    const lieux = [...(data ?? [])]
        .filter((lieu) => !filtre || lieu.room_name.toLowerCase().includes(filtre))
        .sort((a, b) => a.room_name.localeCompare(b.room_name, undefined, { numeric: true }));

    return (
        <BottomSheet ouverte onClose={onFermer} libelle={t('maintenance.lieu.question')} libelleFermeture={t('commun.fermer')}>
            <div className="flex flex-col gap-3">
                <Text variante="titre" as="h2">
                    {t('maintenance.lieu.question')}
                </Text>
                <Input libelle={t('maintenance.lieu.chercher')} valeur={recherche} onChange={setRecherche} type="search" />
                <Button libelle={t('maintenance.lieu.horsChambre')} variante="secondaire" pleineLargeur onPress={() => onChoisir(null)} />
                {isLoading && (
                    <Text variante="petit" ton="attenue">
                        {t('commun.chargement')}
                    </Text>
                )}
                {isError && !data && (
                    <div role="alert" className="flex flex-col items-start gap-2">
                        <Text variante="petit" ton="danger">
                            {t('maintenance.lieu.indisponible')}
                        </Text>
                        <Button libelle={t('commun.reessayer')} variante="secondaire" onPress={() => void refetch()} />
                    </div>
                )}
                <div className="grid grid-cols-3 gap-2">
                    {lieux.map((lieu) => (
                        <Button
                            key={lieu.service_id}
                            libelle={lieu.room_name}
                            variante="secondaire"
                            className="py-4"
                            onPress={() => onChoisir(lieu.service_id)}
                        />
                    ))}
                </div>
            </div>
        </BottomSheet>
    );
}
